import { render, staticRenderFns } from "./BlaiseIcon.vue?vue&type=template&id=0b5bad4a&"
import script from "./BlaiseIcon.vue?vue&type=script&lang=js&"
export * from "./BlaiseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports